// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__UMaBD","hiddenCheckbox":"Switch_hiddenCheckbox__St01l","track":"Switch_track__s_IqH","thumb":"Switch_thumb__SGaD7"};